import { Injectable } from '@angular/core';
import { on } from '@ngrx/store';
import * as actions from './assigned-maintenances.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of, throwError } from 'rxjs';
import { map, mergeMap, catchError, scan } from 'rxjs/operators';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { UserStorageService } from '@ildes/services/user-storage-service.service';

const valIsPendingSync = (pendingSync) => {
  const valuesPendingSync = Object.values(pendingSync || {});

  return Boolean(valuesPendingSync.length && valuesPendingSync.some((val) => val));
}

@Injectable()
export class MaintenancesEffects {

  loadMaintenances$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.loadMaintenances),
      mergeMap((action) => this.fetchData(action).pipe(
        map((data: any) => {
          return actions.loadedMaintenances({
            maintenances: data?.data
          })
        }
        ),
        catchError(error => {
          if (!error.code || error.code > 0) {
            return of(actions.loadedMaintenances({
              maintenances: null
            }))
          }
          const maintenances = this.storageService.getItem('assignedMaintenances');

          return of(actions.loadedMaintenances({
            maintenances
          }))
        })
      ))
    )
  });

  fetchData(action) {
    const params = {
      assigned: action.assigned,
      ...action.state && { state: [action.state] }
    };
    let cachedData = this.storageService.getItem('assignedMaintenances') || [];

    // if (!cachedData?.length) {
    //     return this.apiManager.listMaintenances(params, { error: true, cache: action.options.cache });
    // }

    return this.apiManager.listMaintenances(params, { error: true, cache: action.options.cache })
      .pipe(
        map((data: any) => {
            if (!data.fromCache) {
                cachedData = cachedData.filter(({state, pendingSync}) => Object.values(pendingSync || {})?.length >0);

                this.storageService.setItem('assignedMaintenances', cachedData);

                if (!cachedData?.length) {
                    return data;
                }
            }
            const elementsOutOfPage = cachedData.filter(( { id, pendingSync, pendingNormalising } ) => !data.data.find((maintenance) => maintenance.id === id ) && (valIsPendingSync(pendingSync) || pendingNormalising) );
            const updatedLocalData = data.data.map( (maintenance) => cachedData.find(({ id, updatedAt, pendingSync, pendingNormalising }) => {
                const isPendingSync = valIsPendingSync(pendingSync);

                return id === maintenance.id && (updatedAt > maintenance.updatedAt || isPendingSync || pendingNormalising);
            //return id === maintenance.id && (isPendingSync || pendingNormalising);
            })  || maintenance).map((maintenance) => ({...maintenance, ...{ questionary: maintenance.questionary?.length ? maintenance.questionary : maintenance.answers}}));

            return { data: [...elementsOutOfPage, ...updatedLocalData]};
        }),
        catchError((e) => {
            if (e.code < 0 && cachedData) {
                return of({ data: cachedData });
            }
            return throwError(e);
        })
      );
  }
  constructor(
    private actions$: Actions,
    private apiManager: ApiManagerService,
    private storageService: UserStorageService,
  ) {}
}
